import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import moment from "moment-timezone";
import axios from "axios";
import PropertyService from "./service/property-service";

const NEIGHBORHOOD = "Neighborhood"
const CITY = "City";
const REGION = "Region";

const tagManagerArgs = {
    gtmId: 'GTM-WSWKDVF',
}

export const dataLayerPush = (data) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
};

async function initAxios() {
  console.log("Environment ", process.env.NODE_ENV);
  console.log('Browser Time '+moment.tz.guess());
  if (process.env.REACT_APP_PROXY_HOST_OVERRIDE && process.env.NODE_ENV === "development") {
    axios.defaults.baseURL = process.env.REACT_APP_PROXY_HOST_OVERRIDE; // override default of same as app location proxy
  }
  axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
  axios.defaults.timeout = 20000;
  return await axios.post("https://awsprg01z.prom-online.com/services/oauth2/token", {});
  //return await axios.post("https://awsprg01z.prom-online.com/staging/services/oauth2/token", {}); 
}

const rootDiv = document.getElementById("tourBookingWidget");
if (rootDiv) {
  initAxios().then((response) => {
    axios.defaults.headers["Authorization"] = `${response.data.token_type} ${response.data.access_token}`;
    axios.defaults.headers["Target-URL"] = response.data.instance_url;
    //console.log("Processing Auth Response: ", response.data);
    const propertyService = new PropertyService(moment(), 1, 1);
    propertyService.getAllProperties().then((allProps) => {
      ReactDOM.render(
        <React.StrictMode enabled={false}>
          <App auth={response.data} 
               allPropertyResources={allProps.filter((r) => r.accountType === NEIGHBORHOOD)} 
               allCities={allProps.filter((r) => r.accountType === CITY || r.accountType === REGION)}
               />
        </React.StrictMode>,
        rootDiv
      );
    });
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
